import { BackendResponse } from "../BackendResponse";
import { CvpSettings } from "./CvpSettings";
import { CvpSettingsFromServer, GetSettingsResponse } from "./getSettings";

// UPDATE CODE HERE WHEN ADDING NEW SETTING (5)

export interface MappedGetSettingsResponse
  extends BackendResponse,
    CvpSettings {}

export function mapCvpSettingsFromServer(
  response: GetSettingsResponse
): MappedGetSettingsResponse {
  const s = response.item.settings;

  return {
    ok: response.ok,
    statusCode: response.statusCode,
    __dataId: response.__dataId,
    elapsedMilliseconds: response.elapsedMilliseconds,
    message: response.message,
    result: response.result,
    valueVersion: response.valueVersion,

    // settings
    idConcern: s.idConcern || null,
    idEmbed: s.idEmbed || null,
    backgroundColor: s.backgroundColor || null,
    css: s.css || null,
    cssUrl: s.cssUrl || null,
    departments: s.departments || null,
    fontFamily: s.fontFamily || null,
    fontSize: s.fontSize || null,
    locale: (s.locale as any) || null,
    logoJobFallback: s.logoJobFallback || null,
    logoPrimary: s.logoPrimary || null,
    primaryColor: s.primaryColor || null,
    startPage: s.startPage || null,
    theme: s.theme || null,

    iframe: strToBool(s.iframe),
    iframe_joblist_showLoginButton: strToBool(s.iframe_joblist_showLoginButton),
    jobview_showContactImage: strToBool(s.jobview_showContactImage),
  };
}
function strToBool(value: string): boolean {
  if (!value) return null;
  return value === "1";
}
